import React from 'react';
import styled from 'styled-components';
import { DynamicLink } from '../../../../components';
import { CallToAction } from '../../../../styling/styles';
import { openChat } from '../../../../utils';
import NeedHelpIcon from './NeedHelpIcon';
import BREAK_POINTS from '@soluto-home-web/platform-common-ui/styling/media-queries';

const s = {
  NeedHelpButton: styled(DynamicLink)<{ inverted?: boolean }>`
    ${CallToAction}
    display: flex;
    align-items: center;
    width: fit-content;
    height: 55px;
    font-size: 15px;
    line-height: 1px;
    font-weight: 400;
    font-style: normal;

    @media ${BREAK_POINTS.desktop} {
      font-weight: normal;
    }
  `,
  ExpertsIcon: styled(NeedHelpIcon)`
    margin: -1em 0.5em -1em 0;
  `,
};

export type NeedHelpButtonProps = {
  id: string;
  className?: string;
  text?: string;
  analyticsExtras?: Record<string, string>;
};

const NeedHelpButton = ({
  text = 'Have questions? Message us.',
  id,
  className,
  analyticsExtras,
}: NeedHelpButtonProps) => (
  <s.NeedHelpButton className={className} id={id} onClick={openChat} inverted analyticsExtras={analyticsExtras}>
    <s.ExpertsIcon />
    {text}
  </s.NeedHelpButton>
);

export default NeedHelpButton;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/NeedHelpButton/index.tsx